import { render, staticRenderFns } from "./DocumentDurationKindDropDownSelector.vue?vue&type=template&id=0ad18bf6&scoped=true&"
import script from "./DocumentDurationKindDropDownSelector.vue?vue&type=script&lang=ts&"
export * from "./DocumentDurationKindDropDownSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad18bf6",
  null
  
)

export default component.exports